
  import { Vue, Component, Prop } from "vue-property-decorator";

  import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
  import Search from "@/components/common/Search.vue";
  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
  import ActionsPanelWithFilters from "@/components/common/ActionsPanelWithFilters.vue";
  import EmptyListImageContractors from "@/components/icons/emptyListImages/EmptyListImageContractors.vue";

  @Component({
    components: {
      EmptyListImageContractors,
      Search,
      EmptyListPlaceholder,
      LoadingOverlay,
      ActionsPanelWithFilters,
    },
  })
  export default class SeachableList extends Vue {
    @Prop({ type: Array, default: () => [] }) readonly listItems!: any[];
    @Prop({ type: String, default: undefined }) readonly emptyListSubtitle!: string;
    @Prop({ type: String, required: true }) readonly emptyListTitle!: string;
    @Prop({ type: String, required: true }) readonly emptySearchResultTitle!: string;
    @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
    @Prop({ type: Boolean, default: false }) readonly outsdeSearchTouched!: boolean;
    @Prop({ type: Number, default: 0 }) readonly total!: number;

    searchTouched: boolean = false;

    get isSearchTouched(): boolean {
      return this.outsdeSearchTouched || this.searchTouched;
    }

    get isListItemsPresent(): boolean {
      return this.listItems.length > 0;
    }

    get isListItemsExist(): boolean {
      return this.isSearchTouched || this.isListItemsPresent;
    }

    get isSearchResultEmpty(): boolean {
      return !this.isListItemsPresent && this.isSearchTouched;
    }

    get isEmptyListPlaceholderShown(): boolean {
      return !this.isListItemsExist && !this.loading;
    }

    search(value: string): void {
      if (!this.searchTouched) {
        this.searchTouched = true;
      }
      this.$emit("searchUpdated", value);
    }
  }
